"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploader = void 0;
const react_1 = __importDefault(require("react"));
const react_ioc_1 = require("@servicetitan/react-ioc");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const design_system_1 = require("@servicetitan/design-system");
const confirm_1 = require("@servicetitan/confirm");
const config_1 = require("./config");
const uploader_1 = require("./uploader");
const uuid_1 = require("uuid");
function immutableSplice(arr, start, deleteCount, ...items) {
    return [...arr.slice(0, start), ...items, ...arr.slice(start + deleteCount)];
}
const UploadErrors = ({ errors, className, onClose, multiple }) => {
    const title = multiple
        ? 'One or more files could not be uploaded:'
        : 'Your file could not be uploaded';
    return (react_1.default.createElement(design_system_1.Banner, { icon: true, status: "critical", title: title, className: className, onClose: onClose },
        react_1.default.createElement("ul", { className: "p-x-0-i" }, errors.map(({ id, file, message }) => (react_1.default.createElement("li", { key: id, style: !multiple ? { listStyle: 'none' } : {} },
            multiple && file.name,
            message && (multiple ? ` (${message})` : message)))))));
};
let FileUploader = class FileUploader extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.errors = [];
        this.handleUploadProgress = (file, progress) => {
            if (!this.props.onChange) {
                return;
            }
            const index = this.props.value.findIndex(fileDescriptor => fileDescriptor.file === file);
            if (index !== -1) {
                this.props.onChange(immutableSplice(this.props.value, index, 1, Object.assign(Object.assign({}, this.props.value[index]), { uploadProgress: progress })));
            }
            else {
                this.uploader.cancel(file);
            }
        };
        this.handleUploadSuccess = (file, message) => {
            if (!this.props.onChange) {
                return;
            }
            const index = this.props.value.findIndex(fileDescriptor => fileDescriptor.file === file);
            if (index !== -1) {
                this.props.onChange(immutableSplice(this.props.value, index, 1, Object.assign(Object.assign(Object.assign({}, this.props.value[index]), (message
                    ? { file: message, displayName: file.name, downloadLink: message }
                    : { file: file.name })), { uploadProgress: undefined })));
            }
        };
        this.handleUploadError = (file, message) => {
            if (!this.props.onChange) {
                return;
            }
            this.addError(file, message);
            this.props.onChange(this.props.value.filter(fileDescriptor => fileDescriptor.file !== file));
        };
        this.handleDownload = (file) => {
            var _a, _b, _c, _d;
            if (!file.downloadLink) {
                return;
            }
            const path = (_d = (_b = (_a = this.props.config) === null || _a === void 0 ? void 0 : _a.downloadPath) !== null && _b !== void 0 ? _b : (_c = this.config) === null || _c === void 0 ? void 0 : _c.downloadPath) !== null && _d !== void 0 ? _d : `/app/api/fileuploader/folders/${this.props.folderName}/files/`;
            window.open(path + file.downloadLink);
        };
        this.handleSelected = (files) => {
            if (!this.props.onChange) {
                return;
            }
            this.uploader.upload(files);
            this.props.onChange([
                ...this.props.value,
                ...Array.from(files).map(file => ({
                    file,
                    uploadProgress: 0,
                })),
            ]);
        };
        this.handleReplace = ({ file: { file }, newFile }) => {
            if (!this.props.onChange) {
                return;
            }
            const index = this.props.value.findIndex(fileDescriptor => fileDescriptor.file === file);
            if (index !== -1) {
                this.uploader.upload(newFile);
                this.props.onChange(immutableSplice(this.props.value, index, 1, {
                    file: newFile,
                    uploadProgress: 0,
                }));
            }
        };
        this.handleDelete = ({ file }) => {
            if (!this.props.onChange) {
                return;
            }
            this.props.onChange(this.props.value.filter(fileDescriptor => fileDescriptor.file !== file));
        };
        this.handleErrorsClose = () => {
            this.clearErrors();
        };
    }
    addError(file, message) {
        this.errors.push({
            file,
            message,
            id: uuid_1.v4(),
        });
    }
    clearErrors() {
        this.errors = [];
    }
    componentDidMount() {
        this.uploader = new uploader_1.Uploader(Object.assign(Object.assign({}, this.config), this.props.config), {
            progress: this.handleUploadProgress,
            success: this.handleUploadSuccess,
            error: this.handleUploadError,
        }, this.props.folderName);
    }
    componentWillUnmount() {
        this.uploader.cancel();
    }
    render() {
        const { value, onChange, hideReplace, hideDownload, limitReached, typesNote, multiple, accept, layout, align, } = this.props;
        if (!onChange && !value.length) {
            return null;
        }
        const readonlyProps = onChange
            ? {}
            : {
                onReplace: undefined,
                onDelete: undefined,
                limitReached: true,
            };
        return (react_1.default.createElement(react_1.default.Fragment, null,
            !!this.errors.length && (react_1.default.createElement(UploadErrors, { errors: this.errors, onClose: this.handleErrorsClose, className: "m-b-2", multiple: multiple })),
            react_1.default.createElement(confirm_1.Confirm, { onConfirm: this.handleDelete, title: "Are you sure you want to delete this file?" }, onDelete => (react_1.default.createElement(design_system_1.FilePicker, Object.assign({ value: value.length ? value : undefined, onReplace: !hideReplace ? this.handleReplace : undefined, onSelected: this.handleSelected, onDelete: onDelete, onDownload: !hideDownload ? this.handleDownload : undefined, limitReached: limitReached, typesNote: typesNote, multiple: multiple, accept: accept, layout: layout, align: align }, readonlyProps))))));
    }
};
FileUploader.defaultProps = {
    folderName: 'temp',
};
__decorate([
    react_ioc_1.injectDependency(config_1.FILE_UPLOADER_CONFIGURATION_TOKEN),
    react_ioc_1.optional(),
    __metadata("design:type", Object)
], FileUploader.prototype, "config", void 0);
__decorate([
    mobx_1.observable,
    __metadata("design:type", Array)
], FileUploader.prototype, "errors", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [File, String]),
    __metadata("design:returntype", void 0)
], FileUploader.prototype, "addError", null);
__decorate([
    mobx_1.action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FileUploader.prototype, "clearErrors", null);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], FileUploader.prototype, "handleUploadProgress", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], FileUploader.prototype, "handleUploadSuccess", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], FileUploader.prototype, "handleUploadError", void 0);
FileUploader = __decorate([
    mobx_react_1.observer
], FileUploader);
exports.FileUploader = FileUploader;
//# sourceMappingURL=file-uploader.js.map